import React, { DetailedHTMLProps, HTMLAttributes } from 'react'
import { COLORS } from '../../theme'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: string | number | undefined | string[] | JSX.Element
  fontWeight?: FontWeight
  fontFamily?: 'Montserrat'
  fontStyle?: 'Italic' | ''
  fontSize?: FontSize
  color?: keyof typeof COLORS
  center?: boolean
}

type FontSize = 's' | 'm' | 'l' | 'xl' | 'xxl' | number
type FontWeight = 'ExtraBold' | 'Bold' | 'SemiBold' | 'Medium' | 'Regular' | 'Light' | number

const Text = ({
  children,
  fontWeight = 'Regular',
  fontFamily = 'Montserrat',
  fontStyle = '',
  fontSize = 'm',
  color = 'groupBlue',
  center = false,
  ...other
}: Props): JSX.Element => {
  const textStyles = {
    fontFamily,
    fontSize: fontMapper(fontSize),
    fontWeight: fontWeightMapper(fontWeight),
    color: COLORS[color],
    textAlign: center ? 'center' : ('left' as 'center' | 'left')
  }
  return (
    <div {...other} style={{ ...textStyles, ...other.style }}>
      {children}
    </div>
  )
}

export default Text

const fontMapper = (fontSizeString: FontSize): number => {
  switch (fontSizeString) {
    case 's':
      return 8
    case 'm':
      return 10
    case 'l':
      return 12
    case 'xl':
      return 16
    case 'xxl':
      return 30
    default:
      return fontSizeString
  }
}
const fontWeightMapper = (fontWeightString: FontWeight): number => {
  switch (fontWeightString) {
    case 'ExtraBold':
      return 800
    case 'Bold':
      return 700
    case 'SemiBold':
      return 600
    case 'Medium':
      return 500
    case 'Regular':
      return 400
    case 'Light':
      return 300
    default:
      return fontWeightString
  }
}
